import React from "react";
import { Grid, Paper } from '@mui/material';
import { motion } from "framer-motion/dist/framer-motion";

import OverallWellnessScore from "../personalreport/OverallWellnessScore";
import HealthAge from "../personalreport/HealthAge";
import Information from "../personalreport/Information";

/*
  Contains styles to format the 3-column grid for printing.
  This now uses a more robust grid template to prevent
  columns from collapsing under pressure in the print layout.
*/
const PrintStyles = () => (
    <style>
        {`
        @media print {
            .overview-print-grid {
                display: grid !important;
                /* This is a more robust way to define 3 equal, flexible columns for print */
                grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
                gap: 16px !important;
                padding: 0 !important;
            }

            .pro-paper {
                box-shadow: none !important;
                border: 1px solid #ccc !important;
                height: 100%;
            }

            .pro-grid-item {
                 padding: 0 !important;
            }
        }
        `}
    </style>
);

const motionVariants = {
    hidden: { opacity: 0, x: 0, y: 0 },
    show: {
        opacity: 1, x: 0, y: 0,
        transition: {
            delay: 0.1,
            duration: 0.5,
        }
    }
};

const PersonalReportOverview = (props) => {
    const { component } = props;
    const { settings, PrintView } = props.otherprops;

    return (
        <Grid item xs={12}>
            <PrintStyles />
            <Grid container spacing={2} alignItems="stretch" className="overview-print-grid">
                
                {/* Information Panel */}
                <Grid item lg={4} md={4} sm={12} xs={12} className="pro-grid-item">
                    <motion.div variants={PrintView ? { hidden: { opacity: 1 } } : motionVariants} initial="hidden" animate="show" style={{ height: '100%' }}>
                        <Paper elevation={1} sx={{ padding: '24px', height: '100%' }} className="pro-paper">
                            <Information OWS={component} Settings={settings} PrintView={PrintView} />
                        </Paper>
                    </motion.div>
                </Grid>

                {/* Overall Wellness Score Panel */}
                <Grid item lg={4} md={4} sm={12} xs={12} className="pro-grid-item">
                    <motion.div variants={PrintView ? { hidden: { opacity: 1 } } : motionVariants} initial="hidden" animate="show" style={{ height: '100%' }}>
                        <Paper elevation={1} sx={{ padding: '24px', height: '100%' }} className="pro-paper">
                            <OverallWellnessScore OWS={component} PrintView={PrintView} />
                        </Paper>
                    </motion.div>
                </Grid>

                {/* Health Age Panel */}
                <Grid item lg={4} md={4} sm={12} xs={12} className="pro-grid-item">
                    <motion.div variants={PrintView ? { hidden: { opacity: 1 } } : motionVariants} initial="hidden" animate="show" style={{ height: '100%' }}>
                        <Paper elevation={1} sx={{ padding: '24px', height: '100%' }} className="pro-paper">
                            <HealthAge OWS={component} PrintView={PrintView} />
                        </Paper>
                    </motion.div>
                </Grid>

            </Grid>
        </Grid>
    );
};

export default PersonalReportOverview;